import { createContext, FC, useState, useContext } from 'react';
import { SleeperDataContextProperties, CurrentSleeper } from '@sleepunique/types/sleeper-data-types';

export const SleeperDataContext = createContext<SleeperDataContextProperties>({
  currentSleeper: { questionName: '', sleeper: 0 },
  setCurrentSleeper: () => {},
  sleeperOne: {},
  setSleeperOne: () => {},
  sleeperTwo: {},
  setSleeperTwo: () => {},
});

const { Provider } = SleeperDataContext;

export const SleeperDataProvider: FC = ({ children }) => {
  const [currentSleeper, setCurrentSleeper] = useState<CurrentSleeper>({
    questionName: '',
    sleeper: 0,
  });
  const [sleeperOne, setSleeperOne] = useState<{}>({});
  const [sleeperTwo, setSleeperTwo] = useState<{}>({});

  const value: SleeperDataContextProperties = {
    currentSleeper,
    setCurrentSleeper,
    sleeperOne,
    setSleeperOne,
    sleeperTwo,
    setSleeperTwo,
  };

  return <Provider value={value}>{children}</Provider>;
};

export const useSleeperDataContext = () => {
  const context = useContext(SleeperDataContext);
  if (!context) throw Error('useSleeperDataContext should be used within an SleeprDataProvider');
  return context;
};
